/* eslint-disable camelcase */
import React, { useState, useEffect } from "react";
import { createFragmentContainer } from "react-relay";
import { useTranslation } from "ceco-polyglot";
import { Grid } from "semantic-ui-react";
import { filter } from "lodash";
import graphql from "babel-plugin-relay/macro";
import RecipeInfo from "./RecipeInfo";
import MultimediaFiles from "./MultimediaFiles";
import StepsList from "./StepsIngredients/StepsList";
import AllergensList from "./StepsIngredients/AllergensList";
import IngredientsList from "./StepsIngredients/IngredientsList";
import SectionsList from "./sections/SectionsList";
import RecipeDetails from "./RecipeDetails";
import "./recipe.scss";

function Recipe(props) {
  const {
    recipe,
    allWarnings,
    configConstance,
    allIngredients,
    allUnitMeasure,
    allAllergen,
    allRecipeIngredients,
    summaryIngredient,
    refetchData,
  } = props;

  const [ingredientsParsed, setIngredientsParsed] = useState();
  const [allergenParsed, setAllergenParsed] = useState();

  const t = useTranslation();

  useEffect(() => {
    const ingredientsNodes = allRecipeIngredients.edges.map(({ node }) => {
      if (!node.section) {
        return node;
      }
      return undefined;
    });

    setIngredientsParsed(filter(ingredientsNodes));
  }, [allRecipeIngredients]);

  useEffect(() => {
    const ingredientsNodes = recipe.recipeallergen.edges.map(({ node }) => {
      return node;
    });

    setAllergenParsed(ingredientsNodes);
  }, [recipe.recipeallergen]);

  return (
    <div className="recipe-wrapper">
      <div className="recipe-info">
        <Grid stackable>
          <Grid.Column width={11}>
            <div className="card info">
              <RecipeInfo recipe={recipe} />
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <h3 className="title-section">{t("title.steps")}</h3>
                    <StepsList
                      recipe={recipe}
                      recipeId={recipe.id}
                      steps={recipe.steps}
                      recipeName={recipe.name}
                      allWarnings={allWarnings}
                      summaryIngredient={summaryIngredient}
                      allUnitMeasure={allUnitMeasure}
                      configConstance={configConstance}
                      refetchData={refetchData}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <h3 className="title-section">{t("title.ingredients")}</h3>

                    <IngredientsList
                      recipeName={recipe.name}
                      recipeId={recipe.id}
                      refetchData={refetchData}
                      ingredients={ingredientsParsed}
                      allIngredients={allIngredients}
                      allUnitMeasure={allUnitMeasure}
                    />

                    <SectionsList
                      recipe={recipe}
                      recipeName={recipe.name}
                      refetchData={refetchData}
                      recipeId={recipe.id}
                      allIngredients={allIngredients}
                      allUnitMeasure={allUnitMeasure}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>

              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <h3 className="title-section">{t("title.allergens")}</h3>
                    <AllergensList
                      recipeName={recipe.name}
                      recipeId={recipe.id}
                      allergens={allergenParsed}
                      allAllergen={allAllergen}
                      refetchData={refetchData}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <MultimediaFiles images={recipe} />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </Grid.Column>
          <Grid.Column width={5}>
            <div className="card details">
              <RecipeDetails
                recipe={recipe}
                ingredients={ingredientsParsed}
                summaryIngredient={summaryIngredient}
                refetchData={refetchData}
              />
            </div>
          </Grid.Column>
        </Grid>
      </div>
    </div>
  );
}
export default createFragmentContainer(Recipe, {
  recipe: graphql`
    fragment Recipe_recipe on RecipeNode {
      id
      name
      published
      ...RecipeInfo_recipe
      ...RecipeDetails_recipe

      favoritedBy {
        edges {
          node {
            username
          }
        }
      }
      ...StepsList_recipe

      labels {
        edges {
          node {
            id
            name
          }
        }
      }

      recipeingredientSet {
        edges {
          node {
            id
            comments
            ingredient {
              id
              name
            }

            unityF {
              id
            }

            qty
            section {
              id
              name
            }
            fraction
          }
        }
      }

      recipeallergen(first: null)
        @connection(key: "allergens_recipeallergen", filters: []) {
        edges {
          node {
            id
            allergen {
              id
              name
              icon
            }
          }
        }
      }

      ...SectionsList_recipe

      mediaFiles {
        edges {
          node {
            id
            mediaUrl
          }
        }
      }
    }
  `,
});
